import React from 'react';
import { Card } from 'react-bootstrap';


const ImgTournois = () => {

return (
   <>
        <Card className="bg-dark text-white" style={{borderRadius: "var(--bs-card-border-radius)"}}>
                    <Card.Img src="/img/tournois2.jpg" alt="Card image" />
                    <Card.ImgOverlay>
                    </Card.ImgOverlay>
        </Card><br/>
    </> 

  );
};

export default ImgTournois;
